import React from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';

const ShowMoreButton = ({ url, clang }) => {
    return (
        <Link to={`${url}`} className="show-more" title={lang[clang].show_more}>
            <span>{lang[clang].show_more}</span>
            <span className="show-more__img"></span>
        </Link>
    );
};

ShowMoreButton.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(ShowMoreButton);



// WEBPACK FOOTER //
// ./src/components/simple-search-results/ShowMoreButton.js